<template>
  <Modal v-model="editGuideModal" v-if="editGuideModal" class-name="editGuideStyle" :title="editGuideTitle" width="1000"
    :transfer="false" :mask-closable="false" @on-visible-change="editGuideModalChange">
    <Form :model="editGuideForm" ref="editGuideForm" :rules="ruleValidate"
      :label-width="140" @submit.native.prevent :hide-required-mark="true">
      <Row>
        <languagesTabs ref="formLanguagesTab" @changeLanguagesTabs="changeLanguagesTabs" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="langText('title-label',item.code)" :prop="'title_'+item.code" :class="item.code === 'zh-CN' ?'required_style_label' : ''">
                  <Input :disabled="!isEdit" v-model.trim="editGuideForm['title_'+item.code]" :placeholder="langText('title-placeholder',item.code)" :element-id="'contentTitle_' + item.code"
                    clearable style="width:250px">
                  </Input>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1003062')" prop="moduleId">
                  <div class="flex">
                    <vueTreeSelect
                      style="width:250px"
                      :options="menuData"
                      :normalizer="normalizer"
                      :disable-branch-nodes="true"
                      :zIndex="1000"
                      v-model="editGuideForm.moduleId"
                      :placeholder="$t('key1000101')"
                      @select="handlerSelect"
                    >
                      <template #value-label="{node}">{{ getTreeLabel(node) }}</template>
                    </vueTreeSelect>
                    <Tooltip transfer max-width="300" :content="$t('key1003093')" placement="top">
                      <Icon class="cursor ml10" size="16" type="md-information-circle"/>
                    </Tooltip>
                  </div>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="editGuideForm.moduleId">
                <Form-item :label="$t('key1003063')" prop="showPosition" :class="item.code === 'zh-CN' ?'required_style_label' : ''">
                  <Select v-model="editGuideForm.showPosition" filterable transfer style="width:250px">
                    <Option v-for="(item, index) in displayLocationList" :value="item.value" :key="index">{{ item.name }}</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="editGuideForm.moduleId">
                <Form-item :label="$t('key1003094')" prop="showModuleLocation">
                  <i-switch v-model="editGuideForm.showModuleLocation"/>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1003095')" prop="type" class="radio_styles">
                  <RadioGroup v-model="editGuideForm['contentType_' + item.code]" @on-change="onGuidanceChange(item.code)">
                    <Radio v-for="(item,index) in guidanceTypeList" :key="index" :disabled="!isEdit" :label="item.type">{{ item.name }}</Radio>
                  </RadioGroup>
                </Form-item>
              </Col>
              <div v-if="editGuideForm['contentType_' + item.code] === 0">
                <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <Form-item :label="$t('key1000262')" :prop="'pdf_'+item.code" class="reset_margin" :class="item.code === 'zh-CN' ?'required_style_label' : ''">
                    <div class="flex align-items-center">
                      <Upload
                        style="display: inline-block"
                        :headers="headObj"
                        ref="uploadRef"
                        name='files'
                        v-if="isEdit"
                        :show-upload-list="false"
                        :action="uploadAction"
                        :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList, item.code)"
                        :on-error="uploadError"
                        :on-exceeded-size="uploadExceedSize"
                        :on-format-error="handleFormatError"
                        :max-size="uploadFilesMaxSize"
                        :format="['pdf']">
                        <Button class="mr10">
                          <i class="iconfont mr5">&#xe663;</i>
                          {{ $t('key1000266') }}
                        </Button>
                      </Upload>
                      <template v-if="item.code === 'zh-CN'">
                        <h3 v-if="getExcleFileName(item.code)" class="font-size-13 font-weight-bold ml10">{{ getExcleFileName(item.code) }}</h3>
                      </template>
                      <template v-if="item.code === 'en-US'">
                        <h3 v-if="getExcleFileName(item.code)" class="font-size-13 font-weight-bold ml10">{{ getExcleFileName(item.code) }}</h3>
                      </template>
                    </div>
                  </Form-item>
                </Col>
                <Col push="2" :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                  <div class="tips_styles ml20">
                    {{ $t('key1000270') }}<br/>
                    {{ $t('key1003065') }}<br/>
                    {{ $t('key1003066') }}<br/>
                  </div>
                </Col>
              </div>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-show="editGuideForm['contentType_' + item.code] === 1" class="editor_style">
                <Form-item :label="$t('key1003033')" :prop="'content_'+item.code" label-position="top"
                  :class="item.code === 'zh-CN' ?'required_style_label' : ''">
                  <UE
                    :disabled="!isEdit"
                    :content.sync="editGuideForm['content_' + item.code]"
                    :id="'ueBoxDom_' + item.code"
                    :config=config
                    @change="contentChange(item.code)"
                    :ref="'ueBox_' + item.code">
                  </UE>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1003034')" prop="sort">
                  <InputNumber :max="9999999" :min="1" v-model="editGuideForm.sort" :formatter="value => `${parseInt(value)}`"
                    style="width: 250px">
                  </InputNumber>
                </Form-item>
              </Col>
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="$t('key1003096')" prop="status" class="radio_styles">
                  <i-switch v-model="editGuideForm.showStatus" :true-value="1" :false-value="0"/>
                </Form-item>
              </Col>
            </template>
          </template>
        </languagesTabs>
      </Row>
    </Form>
    <template #footer>
      <Button @click="editGuideModal = false">{{ $t('key1000248') }}</Button>
      <Button type="primary" @click="editGuideBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import UE from "@/components/common/ue.vue";
import supplierMenu from "@/config/menu/supplier";
import ymsMenu from "@/config/menu/yms";
import distributorMenu from "@/config/menu/distributor";
import languagesTabs from "@/components/common/languagesTabs.vue";
import vueTreeSelect from "@riophae/vue-treeselect";
import {getDataSetBatchList, getEnumList} from "@/utils/common";

const defaults = {
  'title_zh-CN': '',
  'title_en-US': '',
  'contentType_zh-CN': 0,
  'contentType_en-US': 0,
  'content_zh-CN': '',
  'content_en-US': '',
  'pdf_zh-CN': '',
  'pdf_en-US': '',
  moduleId: null,
  docsType: 0,
  type: 1,
  sort: 1,
  showModuleLocation: true,
  sortNo: 1,
  originalSort: null,
  showPosition: '1',
  content: '',
  status: 1,
  showStatus: 1,
};

export default {
  name: "editGuideModal",
  components: {vueTreeSelect, languagesTabs, UE},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      editGuideModal: false,
      editGuideTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003012'),
      editGuideForm: JSON.parse(JSON.stringify(defaults)),
      ruleValidate: {},
      guidanceTypeList: [
        {type: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003000')},
        /*{type: 2, name: '站内链接'},*/
        {type: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003001')},
      ],
      systemType: null, // 1分销商系统  2运营系统  3供应商系统
      uploadAction: api.erpCommon_uploadFiles + '?basePath=yms-core-service&action="uploadimage"',
      'excleFileName_zh-CN': null,
      'excleFileName_en-US': null,
      editGuideType: 'add',
      config: { // 富文本编辑器 配置
        initialFrameWidth: null,
        initialFrameHeight: 380,
        serverUrl: api.get_erpCommon_ueditorEnter,
        enableAutoSave: false,
        saveInterval: 0,
        wordCount: false,
        autoHeightEnabled: false,
        imageScaleEnabled: false,
        elementPathEnabled: false, // 禁止显示元素路径
      },
      docsId: null,
      categoryId: null,
      docsType: 0, // 0是自建文档 1是官方文档
      uploadFilesUrl: '',
      normalizer(node) {
        return {
          id: node.menuKey,
          label: node.name,
          children: node.children,
        };
      },
      menuData: [],
      enumData: []
    };
  },
  computed: {
    isEdit() {
      return this.docsType === 0;
    },
    // 显示位置
    displayLocationList() {
      const ENUM_KEY = 'YmsOperatingInstructionsDisplayLocationCoreEnum';
      return getEnumList(this.enumData, ENUM_KEY);
    }
  },
  created() {
    this.systemDefaultLanguage();
  },
  methods: {
    // 初始化数据
    async initGuideData(type, categoryId, system, {docsId, docsType} = {}) {
      let v = this;
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003039'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003085')
      };
      let enumKeyList = ['YmsOperatingInstructionsDisplayLocationCoreEnum'];
      v.enumData = await getDataSetBatchList(enumKeyList);
      v.setMenuBySystem(system);
      this.systemType = Number(3);
      this.editGuideType = type;
      this.editGuideTitle = obj[type];
      this.categoryId = categoryId;
      this.docsId = docsId;
      this['excleFileName_zh-CN'] = null;
      this['excleFileName_en-US'] = null;
      for (let key in defaults) {
        this.editGuideForm[key] = defaults[key];
      }

      if (type === 'add') {
        this.docsType = 0;
        this.editGuideModal = true;
        this.editGuideForm.originalSort = null;
        this.initEditorFun('zh-CN');
      } else {
        this.docsType = docsType;
        this.getGuideDetails(docsId);
      }

    },
    removeUeCache() {
      for (let key in localStorage) {
        if (key.indexOf('ueditor_preference') !== -1) {
          localStorage.removeItem(key);
        }
      }
    },
    changeLanguagesTabs(name) {
      this.initEditorFun(name);
    },
    handlerSelect() {
      this.editGuideForm.showPosition = '1';
      this.editGuideForm.showModuleLocation = true;
    },
    setMenuBySystem(system) {
      if (system === 'ymsCore') {
        this.menuData = eachFilterHideMenu(ymsMenu.menu);
      } else if (system === 'ymsSupplier') {
        this.menuData = eachFilterHideMenu(supplierMenu.menu);
      } else if (system === 'ymsDistributor') {
        this.menuData = eachFilterHideMenu(distributorMenu.menu);
      }

      function eachFilterHideMenu(data, pData) {
        data.forEach((item, index) => {
          // 数据兼容组件
          if (!item.menuKey) {
            item.menuKey = item.children[0].menuKey + '_P';
          }

          if (item.menuHide || item.hideCrumbs || item.type === 'ymsShopping' || ['shop_shopList', 'distributor_shelfTools'].includes(item.menuKey) || (item.distributorType && !item.distributorType.includes('YMS'))) {
            delete data[index];
            if (pData !== undefined) {
              if (pData.children.filter(i => i).length === 0) {
                delete pData.children;
              }
            }
          }
          if (item.children) {
            eachFilterHideMenu(item.children, item);
          }
        });
        return data;
      }
    },
    // 初始化富文本编辑器
    initEditorFun(name) {
      let v = this;
      v.$nextTick(() => {
        let editor = v.$refs['ueBox_' + name][0].editor;
        let userInfo = v.$store.state.erpConfig.userInfo;
        if (editor) {
          let setServerParam = function () {
            editor.execCommand('serverparam', {
              'basePath': 'yms-core-service',
              'userId': userInfo.merchantId + ',' + userInfo.userId
            });
          };
          if (editor.isReady) {
            setServerParam();
          } else {
            editor.addListener('ready', setServerParam);
          }
        }
        setTimeout(() => {
          v.getFocus('contentTitle_' + name);
        }, 800);
      });
    },
    // 获取指引详情数据
    getGuideDetails(docsId) {
      this.axios.get(api.get_helpCenterDocs + docsId, null, {loading: true}).then((res) => {
        this.editGuideModal = true;
        this.initEditorFun('zh-CN');
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            for (let key in this.editGuideForm) {
              if (key === 'showModuleLocation') {
                this.editGuideForm[key] = data[key] === 1;
              } else {
                this.editGuideForm[key] = data[key];
              }
            }
            this.editGuideForm.originalSort = data['sort'];
            (data.docsInternationalQueryResultList || []).forEach((item) => {
              this.editGuideForm['title_' + item.language] = item.title;
              this.editGuideForm['contentType_' + item.language] = item.contentType;
              if (item.contentType === 0) {
                try {
                  const _jsData = JSON.parse(item.content);
                  this.editGuideForm['pdf_' + item.language] = _jsData.url;
                  this['excleFileName_' + item.language] = _jsData.name;
                } catch (e) {
                  this.editGuideForm['pdf_' + item.language] = item.content;
                  this['excleFileName_' + item.language] = item.content;
                }
              } else {
                this.editGuideForm['content_' + item.language] = item.content;
                if (this.$refs['ueBox_' + item.language] && this.$refs['ueBox_' + item.language].length) {
                  this.$refs['ueBox_' + item.language][0].setUEContent(item.content);
                }
              }

            });
          }
        }
      });
    },

    // 上传文件失败
    uploadError() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000250'));
      return false;
    },
    // 控制上传图片大小
    uploadExceedSize() {
      this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000138'));
      return false;
    },
    // 上传文件成功
    uploadSuccess(response, file, fileList, code) {
      let v = this;
      if (response.code === 0) {
        v['excleFileName_' + code] = file.name;
        v.editGuideForm['pdf_' + code] = response.datas[0];
        v.$refs.editGuideForm.validateField('pdf_' + code);
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003057'));
      }
    },
    fixParams() {
      let v = this;
      return v.multilingualNamesList.map(item => {
        let _contentType = v.editGuideForm['contentType_' + item.code];
        let _content = v.$refs['ueBox_' + item.code][0].getUEContent();
        return {
          title: v.editGuideForm['title_' + item.code],
          content: _contentType === 0 ? JSON.stringify({
            name: v['excleFileName_' + item.code],
            url: v.editGuideForm['pdf_' + item.code]
          }) : _content,
          contentType: _contentType,
          language: item.code,
        };
      });
    },
    // 保存按钮
    editGuideBtn() {
      let v = this;
      let text = '';
      let url = '';
      let method = '';
      let params = {
        "categoryId": v.categoryId,
        "docsId": v.docsId,
        "docsInternationalParamBoList": v.fixParams(),
        "docsType": v.editGuideType === 'add' ? 0 : v.editGuideForm.docsType, // 文档类型 0是自建文档 1是官方文档
        "firstShowStatus": 0, // 首页推荐 0否，1是  [
        "moduleId": v.editGuideForm.moduleId,
        "showModuleLocation": v.editGuideForm.showModuleLocation && v.editGuideForm.moduleId ? 1 : 0, //  0否，1是
        "showPosition": v.editGuideForm.moduleId ? v.editGuideForm.showPosition : '0',
        "showStatus": v.editGuideForm.showStatus, //  0否，1是
        "sort": v.editGuideForm.sort,
        "originalSort": v.editGuideForm.originalSort ? v.editGuideForm.originalSort : undefined,
      };
      if (v.editGuideType === 'add') {
        url = api.post_helpCenterDocs;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else if (v.editGuideType === 'edit') {
        url = api.put_helpCenterDocs;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        params.docsId = v.docsId;
      }

      let obj = params.docsInternationalParamBoList.find(item => item.language === 'zh-CN');
      if (!obj.title || !obj.content) {
        v.$refs['formLanguagesTab'].setValue('zh-CN');
      }
      // 提交前生成中文校验规则
      v.ruleValidate = v.buildCnRules();
      v.$nextTick(() => {
        v.$refs['editGuideForm'].validate((valid) => {
          if (valid) {
            v.axios[method](url, params, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(text);
                v.editGuideModal = false;
                v.$emit('updateData', true);
              }
            });
          }
        });
      });
    },
    // 监听弹窗
    editGuideModalChange(value) {
      let v = this;
      if (!value) {
        v.uploadFilesUrl = '';
        v.editGuideForm.content = '';
        v.systemType = null;
        v.docsId = null;
        if (v.$refs.ueBox) {
          v.$refs.ueBox.setUEContent('');
        }
        v.$nextTick(() => {
          v.$refs['editGuideForm'].resetFields();
        });
      } else {
        v.$nextTick(() => {
          if (v.editGuideType === 'add') {
            v.$refs['editGuideForm'].resetFields();
          }
          setTimeout(() => {
            v.getFocus('contentTitle_zh-CN');
          }, 800);
        });
      }
    },

    getExcleFileName(code) {
      return this['excleFileName_' + code];
    },
    langText(type, language) {
      if (type === 'title-label') {
        return language === 'zh-CN' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003086') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003087');
      } else if (type === 'title-placeholder') {
        return language === 'zh-CN' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003088') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003089');
      }
    },
    getTreeLabel(node) {
      let v = this;
      let name = [];
      node.index.reduce((acc, item) => {
        name.push(acc[item].name);
        return acc[item].children;
      }, v.menuData);
      return name.join('->');
    },
    onGuidanceChange(code) {
      setTimeout(() => {
        this.$refs.editGuideForm.validateField('pdf_' + code);
        this.$refs.editGuideForm.validateField('content_' + code);
      }, 300);
    },
    contentChange(code) {
      this.$refs.editGuideForm.validateField('content_' + code);
    },
    // 动态生成中文校验规则
    buildCnRules() {
      const rules = {
        showPosition: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003055'), trigger: 'change'}
        ]
      };
      const langCode = 'zh-CN';
      // 中文标题必填
      rules['title_' + langCode] = [
        {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003090'), trigger: 'change'}
      ];

      // 根据内容类型决定校验 PDF 或 在线内容
      const contentType = this.editGuideForm['contentType_' + langCode];
      if (contentType === 0) { // PDF
        rules['pdf_' + langCode] = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003091'), trigger: 'change'}
        ];
      } else { // 在线内容
        rules['content_' + langCode] = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003092'), trigger: 'change'}
        ];
      }

      return rules;
    },
  },
  watch: {
    'editGuideForm.type': {
      handler(val) {
        let v = this;
        if (val === 3) {
          v.$nextTick(() => {
            let editor = v.$refs['ueBox'].editor;
            let userInfo = v.$store.state.erpConfig.userInfo;
            editor.addListener('ready', function () {
              editor.execCommand('serverparam', {
                'basePath': 'yms-core-service',
                'userId': userInfo.merchantId + ',' + userInfo.userId
              });
            });
          });
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
.editGuideStyle {
  .reset_margin {
    margin-bottom: 8px !important;
  }

  .required_style_label {
    /deep/ .ivu-form-item-label:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }
  }

  .tips_styles {
    color: #9a9797;
    margin: 10px 0 20px 0;
  }

  .editor_style {
    /deep/ .ivu-form-item-content {
      line-height: initial !important;
    }
  }
}

/deep/ .ivu-modal-wrap {
  z-index: 1001 !important;
}

/deep/ .ivu-modal-mask {
  z-index: 1001 !important;
}
</style>
